enum AgentLegalForm {
  COMPANY = "UR",
  PERSON = "FIZ",
  ENTREPRENEUR = "IP",
}

export default AgentLegalForm;
